import { useEffect, useState, type InputHTMLAttributes } from "react";
import { TextInput } from "./text-input";

import { isValidEmail, normalizeEmail } from "@constructorfleet/utils";

export { isValidEmail, normalizeEmail };

type EmailInputProps = Omit<InputHTMLAttributes<HTMLInputElement>, "type" | "onChange"> & {
  /** Called with the raw (untrimmed) value on every keystroke. */
  onChange?: (value: string) => void;
  /** When true, shows an invalid state as soon as the field is non-empty and fails validation. */
  validateOnChange?: boolean;
  onValidation?: (isValid: boolean) => void;
};

export function EmailInput({
  value = "",
  onChange,
  validateOnChange = false,
  onValidation,
  ...props
}: EmailInputProps) {
  const [touched, setTouched] = useState(false);
  const [inputValue, setInputValue] = useState(String(value));
  useEffect(() => {
    setInputValue(String(value));
  }, [value]);
  const validation = isValidEmail(inputValue);
  const showInvalid = touched && validateOnChange && inputValue.trim().length > 0 && !validation.ok;

  return (
    <TextInput
      {...props}
      type="email"
      inputMode="email"
      value={inputValue}
      aria-invalid={showInvalid || undefined}
      data-invalid={showInvalid || undefined}
      onChange={(event) => {
        setTouched(true);
        const newValue = event.target.value;
        setInputValue(newValue);
        onValidation?.(isValidEmail(newValue).ok);
        onChange?.(newValue);
      }}
    />
  );
}
